import React, { useContext, useEffect, useState } from 'react'
import './PlaceOrder.css'
import { StoreContext } from '../../Context/StoreContext'
import { assets } from '../../assets/assets';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import formatPrice from '../../utils/formatPrice';
import OrderSplash from '../../components/OrderSplash/OrderSplash';

const PlaceOrder = () => {

    const [payment, setPayment] = useState("cod")
    const [showSplash, setShowSplash] = useState(false)
    const [data, setData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        street: "",
        city: "",
        state: "",
        zipcode: "",
        country: "",
        phone: ""
    })

    const { getTotalCartAmount, token, food_list, cartItems, url, setCartItems, currency, deliveryCharge } = useContext(StoreContext);

    const navigate = useNavigate();

    const onChangeHandler = (event) => {
        const name = event.target.name
        const value = event.target.value
        setData(data => ({ ...data, [name]: value }))
    }

    const placeOrder = async (e) => {
        e.preventDefault()
        let orderItems = [];
        food_list.forEach((item) => {
            if (cartItems[item._id] > 0) {
                let itemInfo = { ...item };
                itemInfo["quantity"] = cartItems[item._id];
                orderItems.push(itemInfo)
            }
        })
        let orderData = {
            address: data,
            items: orderItems,
            amount: getTotalCartAmount() + deliveryCharge,
        }
        if (payment === "easebuzz") {
            let response = await axios.post(url + "/api/order/place", orderData, { headers: { token } });
            if (response.data.success) {
                const { payment_data, payment_url } = response.data;
                const form = document.createElement('form');
                form.method = 'POST';
                form.action = payment_url;
                Object.entries(payment_data).forEach(([k, v]) => {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = k;
                    input.value = v;
                    form.appendChild(input);
                });
                document.body.appendChild(form);
                form.submit();
            } else {
                toast.error("Kuch toh gadbad ho gayi, dobara try karo!")
            }
        } else {
            let response = await axios.post(url + "/api/order/placecod", orderData, { headers: { token } });
            if (response.data.success) {
                setCartItems({});
                setShowSplash(true);
            } else {
                toast.error("Kuch toh gadbad ho gayi, dobara try karo!")
            }
        }
    }

    useEffect(() => {
        if (!token) {
            toast.error("Pehle sign in karo yaar, order kaise karoge?")
            navigate('/cart')
        } else if (getTotalCartAmount() === 0) {
            navigate('/cart')
        }
    }, [token])

    return (
        <>
            {showSplash && (
                <OrderSplash onDone={() => {
                    setShowSplash(false)
                    navigate('/myorders')
                }} />
            )}
            <form onSubmit={placeOrder} className='place-order'>
                <div className="place-order-left">
                    <p className='title'>Delivery Kahan Karein? 📍</p>
                    <div className="multi-field">
                        <input type="text" name='firstName' onChange={onChangeHandler} value={data.firstName} placeholder='First name' required />
                        <input type="text" name='lastName' onChange={onChangeHandler} value={data.lastName} placeholder='Last name' required />
                    </div>
                    <input type="email" name='email' onChange={onChangeHandler} value={data.email} placeholder='Email address' required />
                    <input type="text" name='street' onChange={onChangeHandler} value={data.street} placeholder='Street / Mohalla' required />
                    <div className="multi-field">
                        <input type="text" name='city' onChange={onChangeHandler} value={data.city} placeholder='City' required />
                        <input type="text" name='state' onChange={onChangeHandler} value={data.state} placeholder='State' required />
                    </div>
                    <div className="multi-field">
                        <input type="text" name='zipcode' onChange={onChangeHandler} value={data.zipcode} placeholder='Pin Code' required />
                        <input type="text" name='country' onChange={onChangeHandler} value={data.country} placeholder='Country' required />
                    </div>
                    <input type="text" name='phone' onChange={onChangeHandler} value={data.phone} placeholder='Phone number' required />
                </div>
                <div className="place-order-right">
                    <div className="cart-total">
                        <h2>Bill Kitna Banta Hai? 🧾</h2>
                        <div>
                            <div className="cart-total-details"><p>Subtotal</p><p>{formatPrice(getTotalCartAmount(), currency)}</p></div>
                            <hr />
                            <div className="cart-total-details"><p>Delivery Fee</p><p>{formatPrice(getTotalCartAmount() === 0 ? 0 : deliveryCharge, currency)}</p></div>
                            <hr />
                            <div className="cart-total-details"><b>Total</b><b>{formatPrice(getTotalCartAmount() === 0 ? 0 : getTotalCartAmount() + deliveryCharge, currency)}</b></div>
                        </div>
                    </div>
                    <div className="payment">
                        <h2>Payment Ka Time 💳</h2>
                        <div onClick={() => setPayment("cod")} className="payment-option">
                            <img src={payment === "cod" ? assets.checked : assets.un_checked} alt="" />
                            <p>Cash on Delivery — Ghar pe dena</p>
                        </div>
                        <div onClick={() => setPayment("easebuzz")} className="payment-option">
                            <img src={payment === "easebuzz" ? assets.checked : assets.un_checked} alt="" />
                            <p>Online Payment — UPI / Card / Netbanking</p>
                        </div>
                    </div>
                    <button className='place-order-submit' type='submit'>
                        {payment === "cod" ? "Place Karo Order! 🚀" : "Payment Pe Jao 💳"}
                    </button>
                </div>
            </form>
        </>
    )
}

export default PlaceOrder
